import {Loc, Dom} from 'main.core';

/**
 * @namespace {BX}
 */
export class BrCalendarExtensionManager {
    blockChatEntries = [];

    static handleLocationHide(mutationsList, observer) {
        for (let mutation of mutationsList) {
            if (mutation.type === 'childList') {
                mutation.addedNodes.forEach(function (node) {


                    if (node?.classList?.contains('calendar-event-location-input-wrap-inner')) {
                        let input = BX.findChild(node, {
                            tagName: 'input',
                            className: 'calendar-field calendar-field-select'
                        }, true)
                        input.setAttribute('readonly', 'readonly');
                    }

                    if (node?.classList?.contains('calendar-add-popup-wrap')) {
                        const calendarContainers = BX.findChildren(node, {className: 'calendar-field-container-info'}, true);
                        if (calendarContainers && calendarContainers.length) {
                            calendarContainers.forEach(function (nodeContainer) {
                                let fieldSelect = BX.findChild(nodeContainer, {className: 'calendar-event-location-input-wrap-inner'}, true);
                                if (fieldSelect) {
                                    let fieldParent = BX.findParent(fieldSelect, {className: 'calendar-field-block'});
                                    if (fieldParent) {
                                        let input = BX.findChild(fieldParent, {
                                            tagName: 'input',
                                            className: 'calendar-field calendar-field-select'
                                        }, true)
                                        input.setAttribute('readonly', 'readonly');
                                    }
                                }
                            });
                        }
                    }
                });
            }
        }
    }

    static registerLocationHideEvents() {
        const observer = new MutationObserver(this.handleLocationHide);
        observer.observe(document.body, {childList: true, subtree: true});
        BX.addCustomEvent('sidepanel.slider:onopencomplete', (SidePanelEvent) => {
            const slider = SidePanelEvent.getSlider();
            if (slider.url === 'calendar:rooms-slider') {
                setTimeout(() => {
                    let parentButton = BX.findParent(BX('add-menu-button'), {className: 'ui-btn-split'})
                    BX.hide(parentButton)
                }, 0)
            }
        });
    }


    registerBlockChatEvents() {
        BX.Event.EventEmitter.subscribe('BX.Main.Popup:onShow', this.popupOnShowHandler.bind(this));
        BX.addCustomEvent('onAjaxSuccess', this.onAjaxSuccessHandler.bind(this));
        BX.addCustomEvent('SidePanel.Slider:onLoad', (SidePanelEvent) => {
            setTimeout(() => {
                const slider = SidePanelEvent.getSlider();
                if (!slider || !slider.options || slider.options.type !== "calendar:slider" || !BX.Calendar.EntryManager.slidersMap.has(slider))
                    return;

                let {entry, control} = BX.Calendar.EntryManager.slidersMap.get(slider);

                if (control.name && (control.name === "eventeditform" || control.name === "eventviewform")) {
                    this.entryId = parseInt(control?.entry?.id);
                }
            }, 0)
        });
    }

    onAjaxSuccessHandler(data, config) {
        this.updateEntries(data, config);
    }

    updateEntries(data, config) {
        if (config && config.url) {
            const url = config.url;

            let hasActionParam = url.includes('action=calendar.api.calendarentryajax.loadEntries');

            const hasAjaxUrl = url.includes('/bitrix/services/main/ajax.php');

            if (data && data.status === "success" && data.data &&
                hasActionParam && hasAjaxUrl) {
                this.blockChatEntries = [];
                data.data.entries.forEach(entry => {
                    if (entry.BR_BLOCK_NEW_CHAT) {
                        this.blockChatEntries.push(parseInt(entry.ID));
                    }
                });
            }
            hasActionParam = url.includes('action=calendar.api.calendareventviewform.getCalendarViewSliderParams');
            if (data && data.status === "success" && data.data &&
                hasActionParam && hasAjaxUrl) {
                this.blockChatEntries = [];
                if (data.data?.event?.BR_BLOCK_NEW_CHAT) {
                    this.blockChatEntries.push(parseInt(data.data.event.ID));
                    this.entryId = parseInt(data.data.event.ID);
                }

            }
        }

    }

    popupOnShowHandler(event) {
        const popup = event.getTarget();
        if (!popup)
            return;
        const popupContainer = popup.getPopupContainer();
        if (!popupContainer)
            return;

        if (popupContainer?.classList?.contains(['calendar-simple-view-popup'])
            || popupContainer?.classList?.contains(['calendar-simple-view-popup-show'])
        ) {
            this.compactViewFormShowHandler();
        } else if (
            popup?.bindElement?.classList?.contains('ui-btn-icon-chat-blue') ||
            popup?.bindElement?.classList?.contains('ui-btn-icon-camera-blue')
        ) {
            //region ���������� �������� ����
            if (
                this.blockChatEntries.includes(parseInt(this.control?.entry?.id)) ||
                this.blockChatEntries.includes(parseInt(this?.entryId))
            ) {
                const chatItem = popupContainer.querySelector('.menu-popup-item-chat');
                if (chatItem) {
                    chatItem.remove()
                }
            }
            //endregion ���������� �������� ����
        }

    }

    compactViewFormShowHandler() {
        this.compactViewFormData = BX.Calendar.EntryManager.getCompactViewForm(false);
        this.control = BX.Calendar.EntryManager.getCompactViewForm(false);

        //region ���������� �������� ����
        if (this.blockChatEntries.includes(parseInt(this.compactViewFormData?.entry?.id))) {
            const uiBtnMain = this.compactViewFormData?.popup?.contentContainer?.querySelector('.calendar-videocall-wrap .ui-btn-main');

            if (uiBtnMain) {
                uiBtnMain.style.visibility = 'hidden';
            }
        }
        //endregion ���������� �������� ����


    }


}